"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9762,4552,8184,163,1681],{

/***/ 16926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Pdp_ProductSchema; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helpers/truthy.ts
var truthy = __webpack_require__(21681);
// EXTERNAL MODULE: ./hooks/useProduct/index.tsx + 6 modules
var useProduct = __webpack_require__(41485);
// EXTERNAL MODULE: ./helpers/turnToApi.ts
var turnToApi = __webpack_require__(9412);
;// CONCATENATED MODULE: ./components/Pdp/ProductSchema/getSchmeaShippingPrice.ts
var priceAnalysisMatrix = [
    {
        min: 50,
        max: 150,
        value: "14.95"
    },
    {
        min: 150,
        max: 250,
        value: "27.95"
    },
    {
        min: 250,
        max: 350,
        value: "37.95"
    },
    {
        min: 350,
        max: 450,
        value: "47.95"
    },
    {
        min: 450,
        max: 650,
        value: "67.95"
    },
    {
        min: 650,
        max: 850,
        value: "87.95"
    },
    {
        min: 850,
        max: 1000,
        value: "97.95"
    }, 
];
var getPDPSchemaShippingPrice = function(param) {
    var price = param.price, isEntryway = param.isEntryway, iswhiteGlove = param.iswhiteGlove;
    var ref;
    if (iswhiteGlove) {
        return "279.00";
    }
    if (isEntryway) {
        return "179.00";
    }
    if (price <= 50) {
        return "9.95";
    }
    var tenPercent = parseFloat("".concat(0.1 * parseFloat("".concat(price || 0)))).toFixed(2);
    return ((ref = priceAnalysisMatrix.find(function(r) {
        return price > r.min && price <= r.max;
    })) === null || ref === void 0 ? void 0 : ref.value) || tenPercent;
};

;// CONCATENATED MODULE: ./components/Pdp/ProductSchema/index.tsx







var getName = function() {
    var str = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref, ref1;
    return ((ref1 = (ref = "".concat(str)) === null || ref === void 0 ? void 0 : ref.split("~")) === null || ref1 === void 0 ? void 0 : ref1[0]) || "";
};
var ProductSchema = function() {
    var ref, ref1, ref2;
    var ref3 = (0,useProduct.useProduct)(), product = ref3.product, sku = ref3.sku, isVintage = ref3.isVintage, selectedVariant = ref3.selectedVariant, inStock = ref3.inStock, rawSalePrice = ref3.digestedPrice.rawSalePrice, warrantyVariant = ref3.warrantyVariant;
    var ref4 = (0,react.useState)(), review = ref4[0], setReview = ref4[1];
    (0,react.useEffect)(function() {
        (0,turnToApi/* getReviewPerSku */._R)(sku).then(setReview);
    }, [
        sku
    ]);
    var inProductGroupwithID = ((ref = (0,_to_consumable_array/* default */.Z)((product === null || product === void 0 ? void 0 : product.category_info) || []).sort(function(a, b) {
        var ref, ref1, ref2, ref3;
        if (((a === null || a === void 0 ? void 0 : (ref = a.path) === null || ref === void 0 ? void 0 : ref.length) || 0) < ((b === null || b === void 0 ? void 0 : (ref1 = b.path) === null || ref1 === void 0 ? void 0 : ref1.length) || 0)) {
            return -1;
        }
        return ((a === null || a === void 0 ? void 0 : (ref2 = a.path) === null || ref2 === void 0 ? void 0 : ref2.length) || 0) > ((b === null || b === void 0 ? void 0 : (ref3 = b.path) === null || ref3 === void 0 ? void 0 : ref3.length) || 0) ? 1 : 0;
    })) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.path) || (product === null || product === void 0 ? void 0 : product.brand_code) || (product === null || product === void 0 ? void 0 : product.sku) || sku;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
        id: "productSchemaScript",
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                "@context": "http://www.schema.org",
                "@type": "product",
                name: getName(product === null || product === void 0 ? void 0 : product.name),
                sku: sku,
                gtin: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.upc,
                brand: !!(product === null || product === void 0 ? void 0 : product.brand) && {
                    "@type": "Brand",
                    name: getName(product === null || product === void 0 ? void 0 : product.brand)
                } || undefined,
                image: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref2 = selectedVariant.images) === null || ref2 === void 0 ? void 0 : ref2.map(function(param) {
                    var url_standard = param.url_standard;
                    return url_standard;
                }),
                description: product === null || product === void 0 ? void 0 : product.meta_description,
                inProductGroupwithID: inProductGroupwithID,
                offers: {
                    "@type": "Offer",
                    availability: "https://schema.org/".concat(inStock ? "InStock" : "OutOfStock"),
                    price: parseFloat("".concat(rawSalePrice)).toFixed(2),
                    priceCurrency: "USD",
                    itemCondition: "https://schema.org/".concat(isVintage ? "UsedCondition" : "NewCondition"),
                    shippingDetails: {
                        "@type": "OfferShippingDetails",
                        shippingRate: {
                            "@type": "MonetaryAmount",
                            value: getPDPSchemaShippingPrice({
                                price: rawSalePrice,
                                isEntryway: (0,truthy.truthy)(warrantyVariant === null || warrantyVariant === void 0 ? void 0 : warrantyVariant.is_entryway),
                                iswhiteGlove: (0,truthy.truthy)(warrantyVariant === null || warrantyVariant === void 0 ? void 0 : warrantyVariant.is_white_glove)
                            }),
                            currency: "USD"
                        },
                        shippingDestination: {
                            "@type": "DefinedRegion",
                            addressCountry: "US"
                        },
                        deliveryTime: {
                            "@type": "ShippingDeliveryTime",
                            handlingTime: {
                                "@type": "QuantitativeValue",
                                unitCode: "DAY",
                                minValue: "0",
                                maxValue: "1"
                            },
                            transitTime: {
                                "@type": "QuantitativeValue",
                                unitCode: "DAY",
                                minValue: "".concat((warrantyVariant === null || warrantyVariant === void 0 ? void 0 : warrantyVariant.estimated_min_delivery_days) || 1),
                                maxValue: "".concat((warrantyVariant === null || warrantyVariant === void 0 ? void 0 : warrantyVariant.estimated_max_delivery_days) || 5)
                            }
                        }
                    }
                },
                aggregateRating: (review === null || review === void 0 ? void 0 : review.averageRating) ? {
                    "@type": "AggregateRating",
                    ratingValue: "".concat((review === null || review === void 0 ? void 0 : review.averageRating) || 0),
                    reviewCount: "".concat((review === null || review === void 0 ? void 0 : review.reviews) || 0)
                } : undefined
            }, undefined, 2)
        }
    });
};
/* harmony default export */ var Pdp_ProductSchema = (ProductSchema);


/***/ }),

/***/ 78184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": function() { return /* binding */ getExperiment; }
/* harmony export */ });
/* unused harmony export sleep */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82222);
/* harmony import */ var _codebuild_output_src3564443245_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3564443245_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3564443245_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27429);




var sleep = function(ms) {
    return new Promise(function(r) {
        return setTimeout(r, ms);
    });
};
var getExperiment = function(param) {
    var experimentId = param.experimentId, _iteration = param.iteration, iteration = _iteration === void 0 ? 0 : _iteration;
    return new Promise(function(resolve) {
        // if darkMode is enabled, by cookie etc., use Variant1
        if (iteration >= 10) {
            resolve("0");
        } else {
            var ref, ref1, ref2;
            (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("getExperiment: ".concat(experimentId, " iteration: ").concat(iteration));
            (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("type of window google optimize: ".concat((0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(window === null || window === void 0 ? void 0 : (ref = window.google_optimize) === null || ref === void 0 ? void 0 : ref.get)));
            var variant = window === null || window === void 0 ? void 0 : (ref1 = window.google_optimize) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.get) === null || ref2 === void 0 ? void 0 : ref2.call(ref1, experimentId);
            if (!variant) {
                resolve("0");
            } else if (variant === "1" || variant === "0") {
                resolve(variant);
            } else {
                sleep(50 + 50 * iteration).then((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3564443245_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    return _codebuild_output_src3564443245_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.t0 = resolve;
                                _ctx.next = 3;
                                return getExperiment({
                                    experimentId: experimentId
                                }, iteration + 1);
                            case 3:
                                _ctx.t1 = _ctx.sent;
                                (0, _ctx.t0)(_ctx.t1);
                            case 5:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))).catch(_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU);
            }
        }
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (getExperiment)));


/***/ }),

/***/ 21681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "truthy": function() { return /* binding */ truthy; }
/* harmony export */ });
var truthy = function(v) {
    if (typeof v === "string") {
        return String(v || "").toLowerCase() === "true";
    }
    if (typeof v === "boolean") {
        return v;
    }
    return false;
};
/* harmony default export */ __webpack_exports__["default"] = (truthy);


/***/ }),

/***/ 82222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ })

}]);